import React from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailSignupModal from "./EmailSignupModal";
import mark1 from "../images/georgiaNative.jpg";
import mark1b from "../images/georgiaNative2.jpg";
import mark2 from "../images/familyPortrait.jpg";
import mark2a from "../images/familyPortrait2.jpg";
import mark2b from "../images/familyPortrait3.jpg";
import howardGraduation from "../images/howardGraduation.jpg";
import howardGraduationb from "../images/howardGraduation2.jpg";
import servantLeader from "../images/servantLeader.jpg";
import servantLeaderb from "../images/servantLeader2.jpg";
import targetImage from "../images/MeetMarkHeader.jpg";
import { useState } from "react";
const MeetMark = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#FFFFFF!important" }}>
      {/* Header Section */}
      <Box
        sx={{
          backgroundImage: `radial-gradient(circle at 78% 30%, rgba(0, 55, 75, 0) 0%, #02449be6 100%), url(${targetImage})`,

          backgroundSize: "cover",
          backgroundPosition: isMobile ? "center" : "top",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          Meet Mark
        </Typography>
      </Box>
      {/* Body Section */}
      <Box
        p={isMobile ? "0 16px" : "96px 96px 48px"}
        sx={{ borderTop: "1px solid #fff", background: "#02449b" }}
      >
        <Grid container alignItems="flex-start">
          {/* Georgia Native Section */}
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid
              item
              display="flex"
              flexDirection="column"
              xs={12}
              md={5}
              my={isMobile ? 2 : 0}
            >
              <img
                src={mark1}
                alt="Mark community"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                A Baltimore native and lifelong Owings Mills resident, Mark
                attended Baltimore County Public Schools for his K–12 education
                and comes from a proud middle-class family that emphasized the
                importance of hard work and commitment. After graduating from
                Coastal Carolina University with a Bachelor of Science degree in
                Business, Mark earned a Master of Public Administration from the
                University of Baltimore and is currently pursuing a Ph.D. in
                Public Policy at the University of Maryland, Baltimore County.
                <br></br>
                <br></br>
                The value of public service and giving back was instilled in
                Mark from a young age. His grandfather was a Korean War veteran
                who served with honor, and his grandmother was a dedicated
                special education teacher who helped shape young lives with
                compassion and patience. Their commitment to service lived on
                through Mark’s parents, who have long been active members of
                their church—leading ministries, mentoring youth, and organizing
                support for families in need. Mark grew up surrounded by
                examples of quiet leadership, faith, and community-minded
                values. Coming from a long line of educators and
                service-oriented individuals, Mark carries that legacy forward
                in his own career, believing deeply that leadership is about
                lifting others up and making a tangible difference in people’s
                lives.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
          {/* Graduation Section */}
          <Grid
            container
            className="section-wrap"
            my={isMobile ? 2 : 12}
            sx={{
              background: isMobile ? "none" : "#106cb7",
              borderRadius: ".5rem",
            }}
          >
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "1" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              mt={isMobile ? 2 : 2}
              sx={{
                order: isMobile ? "3" : "1",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Mark Brewster began his public-service career in college as an
                intern for Congressman Dutch Ruppersberger, an experience that
                showed how effective government can be when it delivers. He
                later served as a full-time aide in Ruppersberger’s Washington
                office and then joined Baltimore County government. Today, Mark
                works for the Baltimore County Department of Health and Human
                Services, where he leads county-wide, cross-agency initiatives
                that put resources directly in residents’ hands. He led a
                project that distributed more than 3,500 free laptops to
                families and launched and ran HHS’s first CASH Campaign tax site
                to provide free tax preparation for lower-income families.
                Beyond his county work, Mark serves on the Board of Directors
                for Maryland Future Business Leaders of America (FBLA), helping
                expand leadership and career-readiness opportunities for
                students across the state. Mark knows how to make government
                work for the people it serves, because he’s been on the ground
                doing it.<br></br>
                <br></br>
                Mark is a committed Democrat and grassroots leader with strong
                ties to both the local and state party. He is a former elected
                member of the Young Democrats of Maryland’s leadership where he
                helped shape the organization’s policy platform while advocating
                in Annapolis for progressive issues like housing, education, and
                environmental justice. Locally, he is an active member of the
                Baltimore County West Democratic Club and the Baltimore County
                Young Democrats, where he has volunteered with democratic
                candidates up and down the ballot. He also previously served as
                an associate member on the Baltimore County Democratic State
                Central Committee, and he was their youngest member at the time
                of his appointment.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              my={18}
              sx={{ display: isMobile ? "none" : "initial", order: "2" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5}
              display="flex"
              flexDirection="column"
              sx={{
                order: isMobile ? "1" : "3",
                padding: isMobile ? "0" : "1rem",
                maxHeight: "fit-content",
              }}
            >
              <img
                src={howardGraduation}
                alt="Mark speaking"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
          </Grid>
          {/* Capital Hill Section */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 0}>
            <Grid
              display="flex"
              flexDirection="column"
              item
              xs={12}
              md={5}
              my={isMobile ? 2 : 0}
            >
              <img
                src={mark2}
                alt="Mark community"
                style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }}
              />
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={1.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
            <Grid
              item
              xs={12}
              md={5.5}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.25rem",

                  color: "white!important",
                }}
              >
                Now, Mark is running for Baltimore County Council in the newly
                drawn 3rd councilmanic district, encompassing communities in
                Randallstown, Owings Mills, Pikesville, Reisterstown,
                Cockeysville, and Windsor Mill. Whether it is fixing potholes
                and streetlights, or addressing code enforcement issues, Mark
                knows that local government is where the rubber meets the road
                and has seen firsthand through his work how the local government
                impacts people’s lives. His government experience, legislative
                advocacy, and generational perspective uniquely position him to
                effectively deliver results on the County Council. <br></br>
                <br></br> He’s committed to addressing the issues that matter
                most to our communities—affordable housing, reliable
                transportation, public safety, education, economic opportunity,
                and environmental sustainability.
                <br></br>
                <br></br>
                With deep connections to the district, years of public service
                experience, and a reputation for results-driven leadership, Mark
                is ready to be a voice for working families, and a champion for
                a more inclusive, transparent, and responsive county government.
                <br></br>
                <br></br>
                Mark currently lives in Owings Mills, just right down the street
                from his childhood home, and he is part of a new generation of
                leaders who believe in listening, building trust, and putting
                people first. He’s committed to bringing bold, forward-thinking
                solutions to the County Council—and hopes you’ll join him in
                building a stronger Baltimore County for all.
                <br></br>
                <br></br>
                Mark is also proud to be running as a publicly financed
                candidate, which is a testament to Mark's commitment to working
                for the people, not special interests.
              </Typography>
            </Grid>
            {/* Divider */}
            <Grid
              item
              xs={false}
              md={0.25}
              sx={{ display: isMobile ? "none" : "initial" }}
            ></Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#106cb7!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/mark.brewster_/profilecard/?igsh=MWVrMDN0eWlzY3E0cQ==/mark_brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/Mark_Brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/profile.php?id=61577947200300"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Mark Brewster; Juna Goldstein, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default MeetMark;
